import React, { useEffect, useState } from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  TextField,
} from "@mui/material";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Spinner from "react-bootstrap/Spinner";
import { gradingMethodService } from "../../../service/settings/manage/gradingMethodService";
import ContentWrapper from "../../../components/common/ContentWrapper";
import Select from "react-select";

function ManageGradingMethod() {
  const [isTableDataLoading, setIsTableDataLoading] = useState(false);
  const [addGradingMethodModal, setAddGradingMethodModal] = useState(false);

  const [grades, setGrades] = useState({});

  const [formData, setFormData] = useState({
    method_name: "",
    description: "",
    status_id: null,
  });
  const [updateGradingMethodModal, setUpdateGradingMethodModal] = useState(false);
  const [isUpdateLoading, setIsUpdateLoading] = useState(false);
  const [updateFormData, setUpdateFormData] = useState({
    grading_method_id: null,
    method_name: "",
    description: "",
    status_id: null,
  });

  useEffect(() => {
    fetchGrades();
  }, []);

  const fetchGrades = async () => {
    try {
      setIsTableDataLoading(true);
      setGrades([]);
      const response = await gradingMethodService.getGradingMethods();
      setGrades(response?.data?.grading_methods);
    } catch (error) {
      console.error(error);
    } finally {
      setIsTableDataLoading(false);
    }
  };

  /* =====================
     HANDLERS
     ===================== */
  const toggleAddGradingMethodModal = () => {
    setAddGradingMethodModal(!addGradingMethodModal);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    try {
      setIsTableDataLoading(true);
      toggleAddGradingMethodModal();

      await gradingMethodService.addGradingMethod(formData);

      fetchGrades();
    } catch (error) {
      console.error(error);
    } finally {
      setIsTableDataLoading(false);
    }
  };

  const handleDeleteGrade = async (id) => {
    try {
      setIsTableDataLoading(true);

      await gradingMethodService.deleteGradingMethod(id);

      fetchGrades();
    } catch (error) {
      console.error(error);
    } finally {
      setIsTableDataLoading(false);
    }
  };

  const toggleUpdateGradingMethodModal = () => {
    setUpdateGradingMethodModal((s) => !s);
  };

  const openUpdateModal = (grade) => {
    setUpdateFormData({
      grading_method_id: grade.grading_method_id,
      method_name: grade.method_name || "",
      description: grade.description || "",
      status_id: Number(grade.status_id),
    });
    setUpdateGradingMethodModal(true);
  };

  const handleUpdateChange = (e) => {
    const { name, value } = e.target;
    setUpdateFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdateSubmit = async () => {
    try {
      setIsUpdateLoading(true);
      // Expects gradingMethodService.updateGradingMethod(id, payload)
      await gradingMethodService.updateGradingMethod(updateFormData.grading_method_id,updateFormData);
      setUpdateGradingMethodModal(false);
      fetchGrades();
    } catch (error) {
      console.error(error);
    } finally {
      setIsUpdateLoading(false);
    }
  };

  return (
    <ContentWrapper>
      <div className="row justify-content-between align-items-center py-5 mb-3">
        <div className="col-md-6 col-6">
          <h3>Manage Grading Method</h3>
        </div>
        {/* <Button variant="primary" onClick={toggleAddGradingMethodModal}>
          Add Grading Method
        </Button> */}
      </div>

      {isTableDataLoading && isTableDataLoading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "60vh" }}
        >
          <Spinner animation="border" />
        </div>
      ) : (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Grading Method Name</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>status</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {grades.length > 0 ? (
              grades.map((grade) => (
                <TableRow key={grade.grading_method_id}>
                  <TableCell>{grade.method_name}</TableCell>
                  <TableCell>{grade.description}</TableCell>
                  <TableCell>
                    {grade.status_id == "1" ? "Active" : "Inactive"}
                  </TableCell>
                  <TableCell align="right">
                    <Button
                      onClick={() => openUpdateModal(grade)}
                      className="btn btn-icon btn-primary btn-sm m-1 edit-assement-btn flaticon-edit-icon"
                      title="Edit Details"
                    />
                    {/* <Button
                      onClick={() => handleDeleteGrade(grade.grading_method_id)}
                      className="btn btn-icon btn-danger btn-sm m-1 delete-assement-btn flaticon-delete"
                      title="Delete"
                    /> */}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  <Spinner animation="border" />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      )}

      {/* =====================
          ADD MODAL
         ===================== */}
      <Modal
        centered
        show={addGradingMethodModal}
        onHide={!addGradingMethodModal}
      >
        <Modal.Header>
          <Modal.Title>Create New Grading Method</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Row className="mb-3">
              <Form.Group as={Col}>
                <Form.Label>Grading Method *</Form.Label>
                <TextField
                  fullWidth
                  name="method_name"
                  onChange={handleChange}
                />
              </Form.Group>
            </Row>

            <Row>
              <Form.Group as={Col}>
                <Form.Label>Description</Form.Label>
                <TextField
                  fullWidth
                  name="description"
                  onChange={handleChange}
                />
              </Form.Group>
            </Row>
            <Form.Group as={Col}>
              <Form.Label>Status *</Form.Label>
              <Select
                options={[
                  { value: "1", label: "Active" },
                  { value: "0", label: "Inactive" },
                ]}
                name="status_id"
                onChange={(selectedOption) =>
                  handleChange({
                    target: {
                      name: "status_id",
                      value: Number(selectedOption.value),
                    },
                  })
                }
              />
            </Form.Group>
            <Row></Row>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary" onClick={handleSubmit}>
            Save
          </Button>
          <Button variant="secondary" onClick={toggleAddGradingMethodModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

  {/* =====================
          UPDATE MODAL
         ===================== */}
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={updateGradingMethodModal}
        onHide={toggleUpdateGradingMethodModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Grading Method</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {isUpdateLoading ? (
            <div className="loading-container" style={{ height: "50px" }}>
              <Spinner animation="border" role="status">
                <span className="sr-only">Please wait...</span>
              </Spinner>
            </div>
          ) : (
            <Form>
              <Row className="mb-3">
                <Form.Group as={Col}>
                  <Form.Label>Grading Method *</Form.Label>
                  <TextField
                    fullWidth
                    name="method_name"
                    value={updateFormData.method_name}
                    onChange={handleUpdateChange}
                  />
                </Form.Group>
              </Row>

              <Row>
                <Form.Group as={Col}>
                  <Form.Label>Description</Form.Label>
                  <TextField
                    fullWidth
                    name="description"
                    value={updateFormData.description}
                    onChange={handleUpdateChange}
                  />
                </Form.Group>
              </Row>

              <Form.Group as={Col} className="mt-3">
                <Form.Label>Status *</Form.Label>
                <Select
                  options={[
                    { value: "1", label: "Active" },
                    { value: "0", label: "Inactive" },
                  ]}
                  value={
                    updateFormData.status_id === 1
                      ? { value: "1", label: "Active" }
                      : { value: "0", label: "Inactive" }
                  }
                  onChange={(selectedOption) =>
                    setUpdateFormData((prev) => ({
                      ...prev,
                      status_id: Number(selectedOption.value),
                    }))
                  }
                />
              </Form.Group>
            </Form>
          )}

          <Modal.Footer>
            <Button variant="primary" onClick={handleUpdateSubmit}>
              Save
            </Button>
            <Button variant="secondary" onClick={toggleUpdateGradingMethodModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal.Body>
      </Modal>
    </ContentWrapper>
  );
}

export default ManageGradingMethod;
